// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O84I1","type":"styles_type__11mmw","choices":"styles_choices__2JOeE"};